module.exports = __webpack_public_path__ + "static/FWB-93d10938ddba037f6452cc535c23fd43.svg";